import { YardDashboardStore } from "./YardDashboard/YardDashboard.Store";
import { YardMapStore } from "./YardMap/YardMap.Store";
import { YardInventoryStore } from "./YardInventory/YardInventory.Store";
import { YardTrailersStore } from "./YardTrailers/YardTrailers.Store";
import YardDialogsStore from "./YardDialogs/YardDialogs.Store";

const yardStoreList = [
    { name: "yardDashboardStore", store: YardDashboardStore },
    { name: "yardMapStore", store: YardMapStore },
    { name: "yardInventoryStore", store: YardInventoryStore },
    { name: "yardTrailersStore", store: YardTrailersStore },
    { name: "yardDialogsStore", store: YardDialogsStore },
];

export default yardStoreList;
